export default "/images/vendor/flag-icons/flags/1x1/wf.svg?311c4e739fa8377d139d07547cb0cc69";